import { render, staticRenderFns } from "./ResumoCard.vue?vue&type=template&id=4604ad82"
import script from "./ResumoCard.vue?vue&type=script&lang=js"
export * from "./ResumoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports